<template>
    <transition  >
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right float-left">
                        <ol class="breadcrumb m-0"> 
                            <li class="breadcrumb-item active">Diagnosis Tests</li>
                            <li class="breadcrumb-item"><a href="javascript: void(0);">Diagnosis Test List</a></li>
                            
                        </ol>
                    </div>
                    <div class="page-title-right float-right"> 
                        <button type="button" class="btn btn-primary float-right" @click="toggleModal()">
                            Add New
                        </button> 
                    </div>
                </div>
            </div>
        </div> 
        <div class="row">
            <div class="col-md-12 ">
                <div class="card">
                    <div class="card-body">
                        <Datatable 
                            :columns="columns" 
                            :sortKey="tableData.sortKey"  
                            @sort="sortBy" 
                            v-if="!loading">
                            <template #header > 
                                <div class="tableFilters" style="margin-bottom: 10px;">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="control" style="float: left;">
                                                <span style="float: left; margin-right: 10px; padding: 7px 0px;">Show </span>
                                                <div class="select" style="float: left;">
                                                    <select class="form-select" v-model="tableData.length" @change="fetchItems()"> 
                                                        <option value="10" selected="selected">10</option>
                                                        <option value="25">25</option>
                                                        <option value="50">50</option>
                                                        <option value="100">100</option>
                                                        <option value="500">500</option>
                                                        <option :value="pagination.total">All</option>
                                                    </select>
                                                </div>
                                                <span style="float: left; margin-left: 10px; padding: 7px 0px;"> Entries</span>
                                            </div>
                                        </div>
                                        
                                        <div class="col-md-2">
                                             
                                        </div>
                                        <div class="col-md-4">
                                            <input type="text" class="form-control" style="float: right;" v-model="tableData.search" placeholder="Search..." @input="fetchItems()">
                                        </div>
                                    </div>
                                </div>   
                            </template> 
                            <template #body >  
                                <tbody v-if="items.length > 0">
                                    <tr class="border" v-for="(item, i) in items" :key="i">
                                      
                                        <td class="text-center">{{ i + 1 }} </td>
                                        <td class="text-center">{{ item.name }} </td>
                                        <td class="text-center">{{ item.parents ? item.parents.name : 'N/A' }} </td> 
                                        <td class="text-center" v-if="item.unit_id != 0">{{ item.test_units ? item.test_units.name : '' }} </td> 
                                        <td class="text-center" v-else>{{ 'N/A' }}</td> 
                                        <td class="text-center">{{ item.diagnosis_categories ? item.diagnosis_categories.name : '' }} </td> 
                                        <td class="text-center">
                                            <span class="badge bg-primary" v-if="item.is_individual == 1">Yes</span> 
                                            <span class="badge bg-danger" v-else>No</span>    
                                        </td> 
                                        <td class="text-center">{{ item.price }} </td> 
                                        <td class="text-center">{{ item.discount }} </td> 
                                        <td class="text-center">
                                            <div class="dropdown float-end">
                                                <a href="#" class="dropdown-toggle arrow-none card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i class="mdi mdi-dots-vertical"></i>
                                                </a>
                                                <div class="dropdown-menu dropdown-menu-end">
                                                    <!-- item-->
                                                    <a href="javascript:void(0);" class="dropdown-item text-warning" @click="edit(item)"><i class="mdi mdi-circle-edit-outline"></i> Edit</a>
                                                    <a href="javascript:void(0);" class="dropdown-item text-danger" @click.prevent="deleteItem(item)"><i class="mdi mdi-delete-outline"></i> Remove</a>
                                                    <!-- item-->
                                                </div>
                                            </div>
                                        </td>
                                    </tr> 
                                </tbody> 
                                <tbody v-else>
                                    <tr>
                                        <td colspan="3"> No Data Available Here!</td>
                                    </tr>
                                </tbody>
                            </template> 
                            <template #footer>
                                <Pagination 
                                    :pagination="pagination"  
                                    :language="lang"
                                    @onChangePage="setPage" > 
                                </Pagination> 
                            </template> 
                        </Datatable>

                        <div class="tab-pane show active" v-if="loading">
                            <div class="row">
                                <div class="col-md-5"></div>
                                <div class="col-md-2">
                                    <img src="../../../assets/image/loading.gif" alt="Loading..." style="width: 130px;">
                                </div>
                                <div class="col-md-5"></div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
        <!-- Modal -->
        <Modal @close="toggleModal()" :modalActive="modalActive">
            <div class="modal-content scrollbar-width-thin">
                <div class="modal-header"> 
                    <h3>Tests Add Or Edit</h3>
                    <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                </div>
                <form @submit.prevent="submitForm()" enctype="multipart/form-data" >
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="name">Name *</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('name')" v-model="form.name" id="name" placeholder="Tests name" autocomplete="off"> 
                                            <div class="invalid-feedback" v-if="errors.name">
                                                {{errors.name[0]}}
                                            </div>
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <label for="category_id" style="float: none;">Category *</label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.category_id"
                                            placeholder="Select Category"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="pcategories"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            v-if="renderOptionComponent"
                                        />                                                   
                                        <div class="invalid-feedback" v-if="errors.category_id">
                                            {{errors.category_id[0]}}
                                        </div>
                                    </div>
                                </div>

                                
                                <div class="row mb-3">
                                    <div class="col-md-6">
                                        <label for="parent_id" style="float: none;">Parent Test</label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.parent_id"
                                            placeholder="Select Parent"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="parent_tests"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false"
                                            v-if="renderOptionComponent"
                                        />                                                   
                                        <div class="invalid-feedback" v-if="errors.parent_id">
                                            {{errors.parent_id[0]}}
                                        </div>
                                    </div>  
                                    <div class="col-md-6">
                                        <label for="unit_id" style="float: none;">Test Unit *</label>
                                        <Multiselect 
                                            class="form-control border" 
                                            mode="single"
                                            v-model="form.unit_id"
                                            placeholder="Select Unit"  
                                            :searchable="true" 
                                            :filter-results="true"
                                            :options="testUnits"
                                            :classes="multiclasses"
                                            :close-on-select="true" 
                                            :min-chars="1"
                                            :resolve-on-load="false" 
                                            :create-option="true" 
                                            :clear-on-select="true"
                                            v-if="renderOptionComponent"
                                        />                                                   
                                        <div class="invalid-feedback" v-if="errors.unit_id">
                                            {{errors.unit_id[0]}}
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <div class="mb-3">
                                                <label for="reference_value">Reference Value </label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('reference_value')" v-model="form.reference_value" id="reference_value" placeholder="Test Reference Value">
                                                <div class="invalid-feedback" v-if="errors.reference_value">
                                                    {{errors.reference_value[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div class="mb-3">
                                                <label for="price">Price *</label>
                                                <input type="text" class="form-control border " @keypress="onkeyPress('price')" v-model="form.price" id="price" placeholder="Price Amount!">
                                                <div class="invalid-feedback" v-if="errors.price">
                                                    {{errors.price[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <div class="mb-3">
                                                <label for="is_individual">It's Individual Test *</label>
                                                <select class="form-control border" v-model="form.is_individual" @change="onkeyPress('is_individual')" id="is_individual">
                                                    <option value="1">Yes</option>
                                                    <option value="0">No</option>
                                                </select>                                                
                                                <div class="invalid-feedback" v-if="errors.description">
                                                    {{errors.description[0]}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row"  >
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="discount">Discount (It's will be count percentage)</label>
                                            <input type="text" class="form-control border " @keypress="onkeyPress('discount')" v-model="form.discount" id="discount" placeholder="Discount amount!">
                                            <div class="invalid-feedback" v-if="errors.discount">
                                                {{errors.discount[0]}}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label for="pcstatus">Status</label>
                                        <select class="form-control border" v-model="form.status" @change="onkeyPress('status')" id="pcstatus">
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="errors.status">
                                            {{errors.status[0]}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer"> 
                        <button type="submit" class="btn btn-danger" @click="toggleModal()">
                            Close
                        </button>
                        <button type="submit" class="btn btn-primary " :disabled="disabled">
                            <span v-show="isSubmit">
                                <i class="fas fa-spinner fa-spin" ></i>
                            </span>{{btn}} 
                        </button>
                        
                    </div>
                </form>
            </div>
        </Modal>
    </div>
    </transition>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../../helper/Modal";
import { ref, onMounted } from "vue";
import Form from 'vform'
import axios from 'axios';

import Datatable from '@/components/Datatable.vue';
import Pagination from '@/components/Pagination.vue';
import { reference } from "@popperjs/core";

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        Datatable,
        Pagination
    },
    props:{
        language: {
          type: Object,
          default: () => {
            return {
              lengthMenu: null,
              info: null,
              zeroRecords: null, 
              search: null
            }
          },
        },
    },
    data() {
        return {
            loading: true,
            isSubmit: false,
            showModal: false,
            editMode:false,
            disabled: false,
            modalActive:false,
            errors: {},
            imagePreview:'',
            btn:'Create',
            renderOptionComponent: true,
            items: [],
            pcategories: [],
            testUnits: [],
            parent_tests: [],
            form: new Form({
                id: '',
                name: '',
                category_id: 0,
                parent_id: 0,
                unit_id: 0,
                reference_value: '',
                price: '',
                is_individual: 1,
                discount:0,
                status: 1,
            }),
            multiclasses: { 
              clear: '',
              clearIcon: '', 
            }, 
            columns: [ 
                {
                    label: 'SL',
                    name: '',           
                    width: '5%'
                },  
                {
                    label: 'Name',
                    name: 'name',           
                    width: '15%'
                },
                {
                    label: 'Parent Test',
                    name: 'parent_id',           
                    width: '15%'
                },
                {
                    label: 'UOM',
                    name: 'unit_id',           
                    width: '10%'
                },

                {
                    label: 'Category',
                    name: 'category_id',
                    width: '20%'
                },
                {
                    label: 'Individual',
                    name: 'is_individual',
                    width: '10%'
                },
                {
                    label: 'Price',
                    name: 'price',
                    width: '15%'
                },
                {
                    label: 'Discount',
                    name: 'discount',
                    width: '10%'
                },
                {
                    label: 'Actions',            
                    name: '',
                    isSearch: false, 
                    isAction: true,
                    width: '5%',

                }
            ],  
            tableData: {
                draw: 0,
                length: 10,
                search: '',
                column: 1,
                // dir: 'desc',
                dir: 'asc',
                sortKey: 'name', 
            }, 
            lang: {
                lengthMenu: this.$props.language.lengthMenu ? this.$props.language.lengthMenu : 'Show_MENU_entries',
                info: this.$props.language.info ? this.$props.language.info : 'Showing_FROM_to_TO_of_TOTAL_entries',
                zeroRecords: this.$props.language.zeroRecords ? this.$props.language.zeroRecords : 'No data available in table.', 
                search: this.$props.language.search ? this.$props.language.search : 'Search'
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
                links:[],
            }, 
        };
    },
    created() {
        this.fetchItems();
        this.fetchDiagnosisCategories();
        this.fetchTestUnits();
    },
    methods: { 
        forceRerender() {
            // Remove my-component from the DOM
            this.renderOptionComponent = false;

            this.$nextTick(() => {
                // Add the component back in
                this.renderOptionComponent = true;
            });
        },
        toggleModal: function() {
            this.modalActive = !this.modalActive;   
            if(!this.modalActive){
                this.editMode = false;
                this.btn='Create';
            } 
            this.errors = '';
            this.isSubmit = false;
            this.form.reset();
        },
        fetchDiagnosisCategories() { 
            this.forceRerender();
            axios.get(this.apiUrl+'/hm/diagnosis_categories', this.headerjson) 
            .then((res) => {
                this.pcategories = res.data.data.map((item) => {
                    return { label: item.name, value: item.id }
                });

            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                //this.loading = false;
            });
        },
        fetchTestUnits() { 
            this.forceRerender();
            axios.get(this.apiUrl+'/hm/test_units', this.headerjson) 
            .then((res) => {
                this.testUnits = res.data.data.map((item) => {
                    return { label: item.name, value: item.id }
                });

            })
            .catch((err) => { 
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                //this.loading = false;
            });
        },

        // Funtion For Pagination 
        fetchItems(url = this.apiUrl+'/hm/diagnosis_tests/list') { 
            this.forceRerender();
            this.tableData.draw++;
            axios.get(url, {params:this.tableData, headers:this.headerparams})
            .then((response) => {
                let data = response.data.data;   
                if(this.tableData.draw = data.draw) { 
                  this.items = data.data.data;
                  this.configPagination(data.data);
                }

                this.parent_tests = data.data.data.map((item) => {
                    if(item.parent_id == 0) {
                        return { label: item.name, value: item.id }
                    }
                }).filter(item => item != null);
            })
            .catch(errors => {
                console.log(errors);
            })
            .finally((fres) => {
                this.loading = false;
            });
        },

        configPagination(data){
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total   = data.total ? data.total : 0;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from ? data.from : 0;
            this.pagination.to = data.to ? data.to : 0;  
            this.pagination.links = data.links;
        },

        sortBy(key,sortable) {
            this.tableData.sortKey = key;
            //this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = sortable; ///this.sortOrders[key] === 1 ? 'asc' : 'desc'; 
            this.fetchItems();
        },
        setPage(data){  
            this.fetchItems(data.url); 
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },

        filterData(){
          this.fetchItems(); 
        },



        edit: function(item) { 
            this.btn='Update';
            this.editMode = true;
            this.toggleModal();
            this.form.fill(item);  
        },
        submitForm: function(e) { 

            this.isSubmit = true;
            this.disabled = true;
            const formData = new FormData();  
            formData.append('name', this.form.name);            
            formData.append('category_id', this.form.category_id);
            formData.append('parent_id', this.form.parent_id ? this.form.parent_id : 0);
            formData.append('unit_id', this.form.unit_id);
            formData.append('reference_value', this.form.reference_value ?? "");
            formData.append('price', this.form.price);
            formData.append('is_individual', this.form.is_individual);
            formData.append('discount', this.form.discount);  
            formData.append('status', this.form.status);  
            if(this.editMode){
                formData.append('_method', 'put');
                // if(this.logoPreview){
                //     this.form.image ? formData.append('image', this.form.image, this.form.image.name) : '';
                // } 
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_tests/'+this.form.id, formData, this.headers);
            }else{ 
                // this.form.image ? formData.append('image', this.form.image, this.form.image.name) : '';
                var postEvent = axios.post(this.apiUrl+'/hm/diagnosis_tests', formData, this.headers);
            }  

            postEvent.then(res => {
                this.isSubmit = false;
                this.disabled = false;
                if(res.status == 200){
                    this.toggleModal();
                    this.fetchItems();
                    this.fetchTestUnits();
                    this.$toast.success(res.data.message); 
                }else{
                    this.$toast.error(res.data.message);
                }
            }).catch(err => { 
                this.isSubmit = false; 
                this.disabled = false;
                this.$toast.error(err.response.data.message);
                if(err.response.status == 422){
                    this.errors = err.response.data.errors 
                }
            });
        },

        onImageChange(e) {
            this.form.image = e.target.files[0]
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length)
                return;  
            
            this.createImage(files[0]);

        },
        createImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => { 
                vm.imagePreview = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        validation: function (...fiels){ 
            var obj = new Object(); 
            var validate = false;
            for (var k in fiels){     // Loop through the object  
                for (var j in this.form){  
                    if((j==fiels[k]) && (!this.form[j])) {  
                        obj[fiels[k]] = fiels[k].replace("_", " ")+' field is required';  // Delete obj[key]; 
                        this.errors = {...this.errors, ...obj};
                    }else{
                        validate = false;
                    }
                }              
            }  
            // var obj = new Object();
            // obj[fiels] = fiels.replace("_", " ")+' field is required';  
            // this.errors = {...this.errors, ...obj}; 
        },
        onkeyPress: function(field) { 
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },
        deleteItem: function(item) {
            this.$swal({
                title: 'Are you sure?',
                text: "You want delete this item!", 
                showCancelButton: true,
                confirmButtonCategory: '#3085d6',
                cancelButtonCategory: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => { 
                if (result.value) { 
                    axios.delete(this.apiUrl+'/hm/diagnosis_tests/'+item.id,this.headers) 
                    .then(res => {
                        if(res.status == 200){  
                            this.fetchItems();
                            this.$toast.success(res.data.message); 
                        }else{
                            this.$toast.error(res.data.message);
                        }
                        console.log(res.data)
                    }).catch(err => {  
                        this.$toast.error(err.response.data.message); 
                    }) 
                }else{
                    // this.$toast.error(`Hey! I'm here`);
                    // this.$toast.warning(`Hey! I'm here`);
                    // this.$toast.info(`Hey! I'm here`)
                }
            }); 
        },

    },
    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 700px;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}
</style>